export default __webpack_public_path__ + "static/media/cat.99c5fe6b.png";